import { type InputHTMLAttributes, useContext, useId, useState } from "react";
import { twMerge } from "tailwind-merge";
import { InputContext } from "./InputContext";

export const InputContainer = (
  props: InputHTMLAttributes<HTMLLabelElement>,
) => {
  const context = useContext(InputContext);
  const generatedInputId = useId();
  const [inputId] = useState(context.inputId ?? generatedInputId);
  const [icon, setIcon] = useState<string>();

  // Disabled placeholder options must not style an enabled select as disabled.
  return (
    <InputContext.Provider
      value={{
        inputId,
        icon: context.icon ?? icon,
        setIcon: context.setIcon ?? setIcon,
      }}
    >
      <label
        htmlFor={inputId}
        className={twMerge(
          "flex items-center gap-3 overflow-hidden rounded-lg border border-solid border-zinc-300 bg-white p-3 text-zinc-900 focus-within:border-black has-[:is(input,select,textarea):disabled]:cursor-not-allowed has-[:is(input,select,textarea):disabled]:border-zinc-200 has-[:is(input,select,textarea):disabled]:bg-zinc-100 has-[:is(input,select,textarea):disabled]:text-zinc-400 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-100 dark:focus-within:border-zinc-600 dark:has-[:is(input,select,textarea):disabled]:border-zinc-800 dark:has-[:is(input,select,textarea):disabled]:bg-zinc-950 dark:has-[:is(input,select,textarea):disabled]:text-zinc-500",
          props.className,
        )}
      >
        {props.children}
      </label>
    </InputContext.Provider>
  );
};
